import React from 'react';
import { createSvgIcon } from '@material-ui/core';
export default createSvgIcon(React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.8105 2.25L6.75 3.3105L15.4395 12L6.75 20.6895L7.8105 21.75L17.5605 12L7.8105 2.25Z" }), 'ChevronRightOutlined');
